import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '../views/Index.vue';
import Logs from '../views/Logs.vue';
import Home from '../views/Home.vue';
import Farms from '../views/Farms.vue';
import Users from '../views/Users.vue';
import Reportes from '../views/Reportes.vue';
import Pacientes from '../views/Pacientes.vue';
import Medicamentos from '../views/Medicamentos.vue';
import Settings from '../views/Settings.vue';
import Paquetes from '../views/Paquetes.vue';

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/imprimir-receta/:id',
    name: 'RecetaImpresion',
    component: () => import('../views/ImprimirReceta.vue'),
    props: true
  },
  {
    path: '/imprimir-solicitud/:id',
    name: 'SolicitudImpresion',
    component: () => import('../views/ImprimirSolicitud.vue'),
    props: true
  },
  {
    path: '/inicio',
    name: 'Inicio',
    component: () => import('../views/ConfiguracionInicial.vue')
  },
  {
    path: '/seleccionar-paquete',
    name: 'Paquetes',
    component: () => import('../views/SeleccionarPaquete.vue')
  },
  {
    path: '/pago-exitoso',
    name: 'PagoExitoso',
    component: () => import('../views/PagoExitoso.vue')
  },
  {
    path: '/pago-exitoso-renovado',
    name: 'PagoExitosoRenovado',
    component: () => import('../views/PagoExitosoRenovado.vue')
  },
  {
    path: '/forgot',
    name: 'Forgot',
    component: () => import('../views/Forgot.vue')
  },
  {
    path: '/verify',
    name: 'Verify',
    component: () => import('../components/Verify.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home
      },
      {
        path: '/logs',
        name: 'Logs',
        component: Logs
      },
      {
        path: '/farms',
        name: 'Farms',
        component: Farms
      },
      {
        path: '/users',
        name: 'Users',
        component: Users
      },
      {
        path: '/reportes',
        name: 'Reportes',
        component: Reportes
      },
      {
        path: '/pacientes',
        name: 'Pacientes',
        component: Pacientes
      },
      {
        path: '/medicamentos',
        name: 'Medicamentos',
        component: Medicamentos
      },
      {
        path: '/settings',
        name: 'Settings',
        component: Settings
      },
      {
        path: '/paquetes',
        name: 'MisPaquetes',
        component: Paquetes
      },
    ]
  },
  {
    path: '*',
    redirect: '/dashboard'
  }
];

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'hash',
  routes
});

export default router;